// Stub for app context
import { createContext, useContext } from 'react';

const AppContext = createContext([
    {
        drawer: null,
        hasBeenOffline: false,
        isOnline: true,
        isPageLoading: false
    },
    {
        closeDrawer: () => {},
        toggleDrawer: () => {}
    }
]);

export const useAppContext = () => useContext(AppContext);
export const AppContextProvider = AppContext.Provider;
export default AppContext;
